import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "required fs-6 fw-semobold mb-1 createAccountTitle" }
const _hoisted_4 = { class: "required fs-6 fw-semobold mb-1 createAccountTitle" }
const _hoisted_5 = { class: "form-control form-control-lg form-control-solid mb-3 bg-light" }
const _hoisted_6 = { class: "mt-7 d-flex flex-row-reverse" }

import { ref, nextTick } from "vue";
import SimpleForm from "@/components/SimpleForm.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { Field } from "vee-validate";
import PaymentService from "@/projects/tenant/modules/Payment/services/PaymentService";


export default /*#__PURE__*/_defineComponent({
  __name: 'BankInfoDetail',
  emits: ["refresh"],
  setup(__props, { expose: __expose, emit: emits }) {



const isLoading = ref(true);
const bankInfoDetailShowRef = ref<any>(null);
const bankInfo = ref({} as any);
const isReadonly = ref(false);

const update = async () => {
  try {
    await PaymentService.putPaymentInformation(
      bankInfo.value.id,
      bankInfo.value
    );
    emits("refresh");
    bankInfoDetailShowRef.value?.hide();
  } catch (e) {
    MsgPrompt.error(e);
  }
};

const show = async (_item: any) => {
  bankInfo.value = _item;
  isReadonly.value = false;
  isLoading.value = false;
  bankInfoDetailShowRef.value?.show();
};

const showReadonly = async (_item: any) => {
  bankInfo.value = _item;
  isReadonly.value = true;
  isLoading.value = false;
  bankInfoDetailShowRef.value?.show();
};

const hide = async () => {
  bankInfoDetailShowRef.value?.hide();
};

__expose({ show, showReadonly });

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "bankInfoDetailShowRef",
    ref: bankInfoDetailShowRef,
    title: _ctx.$t('title.bankInfos'),
    "is-loading": isLoading.value,
    width: 500,
    "disable-footer": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_LoadingRing)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (!isReadonly.value)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(bankInfo.value.info, (value, key) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "key-value-pair",
                      key: key
                    }, [
                      _createElementVNode("label", _hoisted_3, _toDisplayString(key), 1),
                      _createVNode(_unref(Field), {
                        modelValue: bankInfo.value.info[key],
                        "onUpdate:modelValue": ($event: any) => ((bankInfo.value.info[key]) = $event),
                        class: "form-control form-control-lg form-control-solid",
                        type: "text",
                        name: key,
                        autocomplete: "off"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            class: "mb-3",
                            modelValue: bankInfo.value.info[key],
                            "onUpdate:modelValue": ($event: any) => ((bankInfo.value.info[key]) = $event),
                            size: "large"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue", "name"])
                    ]))
                  }), 128))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(bankInfo.value.info, (value, key) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "key-value-pair",
                      key: key
                    }, [
                      _createElementVNode("label", _hoisted_4, _toDisplayString(key), 1),
                      _createElementVNode("div", _hoisted_5, _toDisplayString(value), 1)
                    ]))
                  }), 128)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  class: "btn btn-light btn-danger btn-lg me-3",
                  onClick: hide
                }, _toDisplayString(isReadonly.value ? "Close" : "Cancel"), 1),
                (!isReadonly.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-light btn-success btn-lg me-3",
                      onClick: update
                    }, " Update "))
                  : _createCommentVNode("", true)
              ])
            ]))
      ])
    ]),
    _: 1
  }, 8, ["title", "is-loading"]))
}
}

})